import { useEffect as e } from "react";
import { jsx as t } from "react/jsx-runtime";
//#region third-party/google-publisher-tags/GooglePublisherTags.tsx
var n = ({ shouldRenderPostHydration: n = !1 }) => (e(() => {
	if (!n) return;
	let e = setTimeout(() => {
		let e = document.createElement("script");
		e.async = !0, e.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js", document.head.appendChild(e);
	}, 100);
	return () => clearTimeout(e);
}, [n]), n ? null : /* @__PURE__ */ t("script", {
	async: !0,
	src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
}));
//#endregion
export { n as GooglePublisherTags };
